<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="CustomerInputDto"
            :model="CustomerInputDto"
            class="queryform_div"
            label-width="150px"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.customerName')">
                  <el-input
                    type="text"
                    style="width: 100%"
                    v-model="CustomerInputDto.customerName"
                    size="small"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.customerTypePac')">
                  <el-select
                    v-model="CustomerInputDto.productLine"
                    style="width: 100%"
                    size="small"
                  >
                    <el-option :label="$t('desc.all')" value=""></el-option>
                    <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item
                  :label="
                    $t('title.customerCenter') + '/' + $t('title.liaison')
                  "
                >
                  <template>
                    <el-cascader
                      collapse-tags
                      placeholder=""
                      size="small"
                      :props="{ multiple: true, checkStrictly: true }"
                      v-model="CustomerInputDto.centerList"
                      :options="optionscenterShow"
                      :key="cascaderKey"
                      style="width: 100%"
                    ></el-cascader>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.industry')">
                  <template>
                    <el-cascader
                      v-model="CustomerInputDto.industryList"
                      :options="optionsIndustry"
                      collapse-tags
                      placeholder=""
                      size="small"
                      :props="{ multiple: true, checkStrictly: true }"
                    ></el-cascader>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item
                  :label="$t('title.province') + ' ' + $t('title.city')"
                >
                  <template>
                    <el-cascader
                      v-model="CustomerInputDto.cityList"
                      :options="optionTotalCity"
                      style="width: 100%"
                      collapse-tags
                      placeholder=""
                      size="small"
                      :props="{ multiple: true, checkStrictly: true }"
                    ></el-cascader>
                  </template>
                </el-form-item>
              </el-col>

              <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
                <el-button
                  type="primary"
                  @click="getDataList('search')"
                  size="small"
                  >{{ $t("button.query") }}</el-button
                >
                <el-button @click="resetKeyword" size="small">{{
                  $t("button.reset")
                }}</el-button>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="showDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasCreateAuth"
              >{{ $t("button.addCustomer") }}</el-button
            >
            <el-button
              type="default"
              icon="el-icon-upload2"
              @click="showImportDialog(true)"
              style="margin-bottom: 10px"
              v-show="hasImportAuth"
              >{{ $t("button.bulkImport") }}</el-button
            >
            <el-button
              type="default"
              @click="exportCustomerList()"
              :loading="loading"
              v-if="hasExportAuth"
              style="margin-bottom: 10px"
              >{{ $t("button.exportCustomerList") }}</el-button
            >
            <a
              v-if="activeLang == 'en'"
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/Excel Import Template - Customer.xlsx"
              download="Excel Import Template - Customer.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <a
              v-else
              class="el-button el-button--default el-button--small"
              style="margin-bottom: 10px; text-decoration: none; float: right"
              href="/file/EXCEL导入模板-客户.xlsx"
              download="EXCEL导入模板-客户.xlsx"
              >{{ $t("desc.exportTemplate") }}</a
            >
            <div class="tableDiv">
              <el-table
                :data="tableData1"
                stripe
                style="width: 100%"
                :empty-text="$t('desc.noData')"
              >
                <el-table-column
                  type="index"
                  :label="$t('title.serialNumber')"
                  width="60"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="customerName"
                  :label="$t('desc.customerName')"
                  min-width="150px"
                  fixed="left"
                >
                </el-table-column>
                <el-table-column
                  prop="customerCode"
                  :label="$t('title.customerCode')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="brand"
                  :label="$t('title.brand')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="customerCenter"
                  :label="$t('title.customerCenter')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="customerType"
                  :label="$t('title.customerTypePac')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="manageCpName"
                  :label="$t('title.managementUnit')"
                  min-width="200px"
                >
                </el-table-column>
                <el-table-column
                  prop="manageCpCode"
                  :label="$t('title.managementCode')"
                  min-width="250px"
                >
                </el-table-column>
                <el-table-column
                  prop="companyType"
                  :label="$t('title.companyType')"
                  min-width="200px"
                >
                </el-table-column>
                <el-table-column
                  prop="provinceName"
                  :label="$t('title.province')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="cityName"
                  :label="$t('title.city')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('title.address')"
                  min-width="200px"
                >
                </el-table-column>
                <el-table-column
                  prop="industry"
                  :label="$t('title.industry')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="longitude"
                  :label="$t('title.longitude')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  prop="latitude"
                  :label="$t('title.latitude')"
                  min-width="150px"
                >
                </el-table-column>
                <el-table-column
                  :label="$t('title.operate')"
                  min-width="110px"
                  fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                        v-if="isAdmin"
                        type="primary"
                        icon="el-icon-info"
                        :title="$t('button.healthReport')"
                        circle
                        size="mini"
                        @click="showCustomerHealthReportListDialog(true, scope.row)"
                    ></el-button>
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      :title="$t('button.update')"
                      circle
                      size="mini"
                      v-show="hasUpdateAuth"
                      @click="showEditDialog(true, scope.row.id)"
                    ></el-button>
                    <template>
                      <el-popconfirm
                        placement="top"
                        :confirmButtonText="$t('button.delete')"
                        :cancelButtonText="$t('button.cancel')"
                        icon="el-icon-info"
                        iconColor="red"
                        :title="$t('title.confirmDelete')"
                        @confirm="deleteCustomer(scope.row.id)"
                      >
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          :title="$t('button.delete')"
                          circle
                          size="mini"
                          slot="reference"
                          v-show="hasDeleteAuth"
                        ></el-button>
                      </el-popconfirm>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                :page-size="pagination.pageSize"
                :page-sizes="[10, 20, 50]"
                :current-page.sync="pagination.current"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                layout="prev, pager, next,sizes"
                :total="pagination.totalPage"
                style="text-align: center; margin-top: 10px"
              >
              </el-pagination>
            </div>
          </template>
        </el-main>
      </el-scrollbar>
    </el-container>
    <cust-dialog
      ref="addRef"
      :refForm="'airFormAdd'"
      :title="(dialogTitle = $t('button.addCustomer'))"
      :clientform="clientform"
      :dialogAddClient="dialogAddClient"
      :optionsIndustry="optionsIndustry"
      :optionRegion="optionRegion"
      :subButtonAuth="hasCreateAuth"
      :isAdd="(isAdd = true)"
      :isRequiredAgency="isRequiredAgency"
      :brandInfo="brandInfo"
      :dialogAddMethod="dialogAddMethod"
      :productLineArr="productLineArr"
      :loading="submitLoading"
      @onSubBtn="addCustomer"
      @dialogVisibleEvent="showDialog"
      @officeChange="officeChange"
      @typeChange="typeChange"
    >
    </cust-dialog>

    <cust-dialog
      ref="editRef"
      :refForm="'airFormEdit'"
      :title="(dialogTitle = $t('button.updateCustomer'))"
      :clientform="clientform"
      :dialogAddClient="dialogEditClient"
      :optionsIndustry="optionsIndustry"
      :optionRegion="optionRegion"
      :subButtonAuth="hasUpdateAuth"
      :isAdd="(isAdd = false)"
      :isRequiredAgency="isRequiredAgency"
      :brandInfo="brandInfo"
      :dialogAddMethod="dialogEditMethod"
      :productLineArr="productLineArr"
      :loading="submitLoading"
      @onSubBtn="updateCustomer"
      @dialogVisibleEvent="showEditDialog"
      @officeChange="officeChange"
      @typeChange="typeChange"
    >
    </cust-dialog>
    <import-dialog
      ref="importRef"
      :refForm="'airFormImport'"
      :title="(dialogTitle = $t('title.batchImportCustomer'))"
      :dialogImportClient="dialogImportClient"
      :form="form"
      :loading="importLoading"
      @onSubBtn="uploadFile"
      @dialogVisibleEvent="showImportDialog"
    ></import-dialog>
    <el-dialog :visible.sync="showCustomerHealthReport" :before-close="doCustomerHealthReportClose" width="90%" top="5%" class="abow_dialog"
               :modal-append-to-body="false">
      <div class="tableDiv">
        <el-table :data="customerHealthReportList" stripe style="width: 100%" class="alarmTable" height="432px"
                  :key="tableKey">
          <el-table-column type="index" :label="$t('title.serialNumber')" width="60" fixed="left">
          </el-table-column>
          <el-table-column prop="customerName" :label="$t('title.customerName')" min-width="100px">
          </el-table-column>
          <el-table-column prop="cycle" :label="$t('title.cycle')" min-width="100px">
          </el-table-column>

          <el-table-column prop="dsns" :label="$t('title.dsns')" min-width="200px">
          </el-table-column>
          <el-table-column prop="gsns" :label="$t('title.gsns')" min-width="400px">
          </el-table-column>
          <el-table-column prop="creationTime" :label="$t('title.creationTime')" min-width="120px">
          </el-table-column>
          <el-table-column :label="$t('title.operate')" width="110" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-document" :title="$t('desc.viewDetail')" circle
                         size="mini" @click="openReportCustomizationDialog(true, scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :page-size="paginationHealthReport.pageSize" :page-sizes="[10, 20, 50]"
                       :current-page.sync="paginationHealthReport.current" @current-change="handleHealthReportCurrentChange"
                       @size-change="handleHealthReportSizeChange" layout="prev, pager, next,sizes"
                       :total="paginationHealthReport.totalPage">
        </el-pagination>
      </div>
    </el-dialog>
    <report-customization ref= "reportCustomization" @dialogVisibleEvent="closeReportCustomization" :dsn="dsns" :gsn="gsns" :health-report-id="healthReport.id" :cycle-type="cycleType" :cycle="healthReport.cycle" :is-customer="isCustomer"/>

  </div>
</template>
<script>
import {
  addCustomer,
  authOperationCheck,
  deleteCustomer,
  exportExcelNew,
  getBrandInfos,
  getCustById,
  GetCustomerHealthReportList,
  getCustomerList,
  getCustomerRegionTree,
  getExportCustomerList,
  getIndustryTree,
  getProductLines,
  getRegionTree,
  getRegionTreeByOfficeId,
  importCustomer,
  updateCustomer
} from "../../api/api";
// import {icons} from '../../assets/fonts/font-awesome';
import { mapGetters, mapState } from "vuex";
import custDialogComponent from "../../components/content/maintabber/CustDialogC";
import custImportComponent from "../../components/content/maintabber/ExportExcelFile";
import ReportCustomization from "../report/ReportCustomization";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
export default {
  name: "index",
  components: {
    "report-customization": ReportCustomization,
    "cust-dialog": custDialogComponent,
    "import-dialog": custImportComponent,
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  watch: {
    optionscenterShow(val) {
      this.cascaderKey++;
    },
  },
  data() {
    return {
      isAdmin: false,
      submitLoading: false,
      cascaderKey: 1,
      tableKey: '',
      loading: false,
      importLoading: false,
      companyTypeList: {
        直管: "desc.straightPipe",
        经销商: "desc.dealer",
        服务经销商: "desc.serviceDistributor",
        中间商: "desc.middleman",
        其他: "desc.other",
      },
      isRequiredAgency: false,
      isAdd: true,
      dialogTitle: "",
      dialogAddClient: false,
      dialogEditClient: false,
      dialogEditMethod: false,
      dialogAddMethod: false,
      dialogImportClient: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      hasImportAuth: false,
      hasExportAuth: false,
      tableData1: [],
      CustomerInputDto: {
        CustomerName: "",
      },
      clientform: {
        CustomerName: "",
        CustomerCode: "",
        CustomerCodeShow: "",
        CustomerCenter: "",
        RegionList: [],
        IndustryList: [],
        ProvinceList: [],
        ManageCpName: "",
        ManageCpCode: "",
        AgencyId: "",
        ProvinceName: "",
        CityName: "",
        Address: "",
        Industry: "",
        CompanyType: "",
        Longitude: "",
        Latitude: "",
      },
      optionscenter: [],
      optionscenterShow: [],
      optionsIndustry: [],
      optionRegion: [],
      optionTotalCity: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      paginationHealthReport: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      form: {
        datalist: [],
      },
      props: { multiple: true },
      brandInfo: {},
      productLineArr: [],
      showCustomerHealthReport: false,
      customerHealthReportList: [],
      currentCustomer: null,
      healthReport:{},
      dsns: "",
      gsns: "",
      cycleType: "month",
      isCustomer: true
    };
  },
  created: function () {
    this.authOperation("Customer");
    let name = getItemFormLocalstorage('userName');
    let roles = getItemFormLocalstorage('roles')
    if (name === 'admin' || roles.some(r => r === 'Admin' || r === 'Admin Product')) {
      this.isAdmin = true;
    }
  },
  async mounted() {
    this.getDataList();

    this.getIndustryTree();
    this.getRegionTree();
    this.getBrandInfos();
    await this.getProductLines();
    await this.getCustomerRegionTree();
  },
  methods: {
    openReportCustomizationDialog(visible, row) {
      this.healthReport = row;
      this.dsns = row.dsns;
      this.gsns = row.gsns;
      this.isCustomer = true;
      this.$refs.reportCustomization.showDialog();
    },
    closeReportCustomization() {
      this.healthReport = {};
      this.dsns = "";
      this.gsns = "";
    },
    showCustomerHealthReportListDialog(flag, row) {
      this.showCustomerHealthReport = flag;
      if (flag) {
        this.currentCustomer = row;
        this.getCustomerHealthReportList(row);
      }
    },
    doCustomerHealthReportClose() {
      this.showCustomerHealthReport = false;
      this.tableKey = null;
      this.paginationHealthReport = {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      };
      this.customerHealthReportList = [];

    },
    getCustomerHealthReportList(row) {
      let postData = {
        customerId: row.id,
        skipCount: (this.paginationHealthReport.current - 1) * this.paginationHealthReport.pageSize,
        maxResultCount: this.paginationHealthReport.pageSize,
      };
      GetCustomerHealthReportList(postData).then((res) => {
        this.tableKey = Math.random();
        this.paginationHealthReport.totalPage = res.result.totalCount;
        this.customerHealthReportList = res.result.items;
      });
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfos();
      let brandCode = localStorage.getItem("user_brand")
        ? localStorage.getItem("user_brand")
        : "IR";
      that.brandInfo = res.result.find((x) => x.brandCode == brandCode);
    },
    async getProductLines() {
      let that = this;
      let res = await getProductLines();
      that.productLineArr = res.result;
    },
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      that.hasImportAuth = res.hasImportAuth;
      that.hasExportAuth = res.hasExportAuth;
    },
    getCustomerRegionTree() {
      let that = this;
      getCustomerRegionTree().then((res) => {
        let data = res.result;
        for (let index = 0; index < that.productLineArr.length; index++) {
          const element = that.productLineArr[index];
          let obj = {
            brand: that.brandInfo.brandCode,
            centerType: element.bnDictCode,
            label: element.bnDictName,
            value: element.bnDictCode,
            children: data.filter((x) => x.centerType == element.bnDictCode),
          };
          that.optionscenter.push(obj);
        }
        this.optionscenterShow = JSON.parse(JSON.stringify(that.optionscenter));
      });
    },
    getIndustryTree() {
      let that = this;
      getIndustryTree(this.activeLang).then((res) => {
        let data = res.result;
        that.optionsIndustry = data;
      });
    },
    getRegionTree() {
      let that = this;
      getRegionTree().then((res) => {
        let data = res.result;
        that.optionTotalCity = data;
      });
    },
    officeChange(value) {
      let that = this;
      let postData = { CustCenter: value };
      getRegionTreeByOfficeId(postData).then((res) => {
        let data = res.result;
        that.optionRegion = data;
        this.$set(this.clientform, "ProvinceList", []);
      });
    },
    getDataList(type = "normal") {
      let that = this;
      if (type == "search") {
        this.pagination.current = 1;
      }
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      // let productline = new Array();
      // let centerlist = new Array();
      // if (this.CustomerInputDto.centerList && this.CustomerInputDto.centerList.length > 0) {
      //   for (let index = 0; index < this.CustomerInputDto.centerList.length; index++) {
      //     let element = JSON.parse(JSON.stringify(this.CustomerInputDto.centerList[index]));
      //     if (element.length>0 && productline.findIndex(x=>x == element[0])==-1) {
      //       productline.push(element.shift());
      //     }
      //     if (element.length>0) {
      //       centerlist.push(element);
      //     }
      //   }
      // }
      let postData = {
        CustomerName: this.CustomerInputDto.customerName,
        IndustryList: this.CustomerInputDto.industryList,
        CityList: this.CustomerInputDto.cityList,
        CenterList: this.CustomerInputDto.centerList,
        ProductLine: this.CustomerInputDto.productLine,
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
        Language: this.activeLang,
      };
      getCustomerList(postData).then((res) => {
        let data = res.result.items;
        for (let index = 0; index < data.length; index++) {
          data[index].companyType = this.$t(
            this.companyTypeList[data[index].companyType]
          );
          data[index].customerType =
              data[index].customerType == "Other"
                ? "Rotary"
                : data[index].customerType;
        }
        this.pagination.totalPage = res.result.totalCount;
        that.tableData1 = data;
      });
    },
    addCustomer() {
      let that = this;
      that.submitLoading = true;
      addCustomer(that.clientform)
        .then((res) => {
          that.submitLoading = false;
          that.dialogAddClient = false;
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          that.submitLoading = false;
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    deleteCustomer(e) {
      let that = this;
      let data = { id: e };
      deleteCustomer(data)
        .then((res) => {
          that.$message({
            showClose: true,
            message: this.$t("tips.deleteSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    updateCustomer() {
      let that = this;
      that.submitLoading = true;
      updateCustomer(that.clientform).then((res) => {
        that.$message({
          showClose: true,
          message: that.$t("tips.updateSuccess"),
          type: "success",
        });
        that.submitLoading = false;
        that.dialogEditClient = false;
        that.getDataList();
        this.clientform = {
          CustomerName: "",
          CustomerCode: "",
          CustomerCodeShow: "",
          CustomerCenter: "",
          RegionList: [],
          IndustryList: [],
          ProvinceList: [],
          ManageCpName: "",
          ManageCpCode: "",
          ProvinceName: "",
          CityName: "",
          Address: "",
          Industry: "",
          CompanyType: "",
          Longitude: "",
          Latitude: "",
        };
      });
    },
    async getCustById(e) {
      let that = this;
      let data = { id: e };
      await getCustById(data).then((res) => {
        that.clientform = res.result;
        that.clientform.customerCenter = res.result.RegionList;
        that.clientform.customerCodeShow = res.result.customerCode;
        this.officeChange(this.clientform.regionList);
        this.typeChange(this.clientform.companyType, this.clientform.agencyId);
      });
    },
    showDialog(visible) {
      this.dialogAddClient = visible;
      this.dialogAddMethod = visible;
      if (visible) {
        this.clientform = {
          CustomerCenter: "",
          RegionList: [],
          IndustryList: [],
          ProvinceList: [],
          ManageCpName: "",
          ManageCpCode: "",
          ProvinceName: "",
          CityName: "",
          Address: "",
          Industry: "",
          CompanyType: "",
          Longitude: "",
          Latitude: "",
        };
        this.$set(this.clientform, "brandCode", this.brandInfo.brandCode);
        if (this.$refs.addRef.$refs.airFormAdd != undefined) {
          this.$refs.addRef.$refs.airFormAdd.resetFields();
        }
      }
    },
    async showEditDialog(visible, id) {
      this.dialogEditClient = visible;
      if (visible) {
        await this.getCustById(id);
        //窗口打开可能会有延迟

        this.dialogEditMethod = visible;
        if (this.$refs.editRef.$refs.airFormAdd != undefined) {
          this.$refs.editRef.$refs.airFormAdd.resetFields();
        }
      } else {
        this.dialogEditMethod = visible;
        this.clientform = {
          CustomerName: "",
          CustomerCode: "",
          CustomerCenter: "",
          RegionList: [],
          IndustryList: [],
          ProvinceList: [],
          ManageCpName: "",
          ManageCpCode: "",
          ProvinceName: "",
          CityName: "",
          Address: "",
          Industry: "",
          CompanyType: "",
          Longitude: "",
          Latitude: "",
        };
        if (this.$refs.editRef.$refs.airFormAdd != undefined) {
          this.$refs.editRef.$refs.airFormAdd.resetFields();
        }
      }
    },
    typeChange(value, id) {
      if (value !== "直管") {
        this.isRequiredAgency = true;
      } else {
        this.isRequiredAgency = false;
      }
      this.$set(this.clientform, "agencyId", id);
    },
    openNotice(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type,
      });
    },
    togleCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    handleAccredit(index, row) {},
    handleDelete(index, row) {},
    onSubmit() {},

    resetKeyword() {
      this.CustomerInputDto = {};
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDataList();
    },
    handleHealthReportCurrentChange(val) {
      this.paginationHealthReport.current = val;
      this.getCustomerHealthReportList(this.currentCustomer);
    },
    handleHealthReportSizeChange(val) {
      this.paginationHealthReport.pageSize = val;
      this.getCustomerHealthReportList(this.currentCustomer);
    },
    showImportDialog(visible) {
      this.dialogImportClient = visible;
      this.form.datalist = [];
      if (this.$refs.importRef.$refs.airFormImport != undefined) {
        this.$refs.importRef.$refs.airFormImport.resetFields();
      }
    },
    changeTypeP() {
      this.optionscenterShow = this.optionscenter.filter(
        (x) => x.centerType == this.CustomerInputDto.productLine
      );
    },
    exportTemplate() {
      window.location.href =
        "/src/assets/excel/副本英格索兰IoT项目问题清单.xlsx";
    },
    exportCustomerList() {
      this.loading = true;
      let that = this;
      // var data = {
      //   Ccn: ccn,
      //   Version: version,
      // };
      // var headers = [
      //   { key: "customerName", title: "客户名称" },
      //   { key: "customerCode", title: "客户编码" },
      //   { key: "customerCenter", title: "客户中心" },
      //   { key: "manageCpName", title: "管理单位名称" },
      //   { key: "manageCpCode", title: "管理单位代码" },
      //   { key: "companyType", title: "单位性质" },
      //   { key: "provinceName", title: "省" },
      //   { key: "cityName", title: "市" },
      //   { key: "address", title: "地址" },
      //   { key: "industry", title: "行业" },
      //   { key: "longitude", title: "经度" },
      //   { key: "latitude", title: "纬度" },
      // ];
      var exportData = [
        [
        this.$t('desc.customerName'),
        this.$t('title.customerCode'),
        this.$t('title.brand'),
        this.$t('title.customerCenter'),
        this.$t('title.customerTypePac'),
        this.$t('title.managementUnit'),
        this.$t('title.managementCode'),
        this.$t('title.companyType'),
        this.$t('title.province'),
        this.$t('title.city'),
        this.$t('title.address'),
        this.$t('title.industry'),
        this.$t('title.longitude'),
        this.$t('title.latitude'),
        ],
      ];
      var fileName = this.$t("exportContent.客户列表导出") + ".xlsx";
      let postData = {
        CustomerName: this.CustomerInputDto.customerName,
        IndustryList: this.CustomerInputDto.industryList,
        CityList: this.CustomerInputDto.cityList,
        CenterList: this.CustomerInputDto.centerList,
        ProductLine: this.CustomerInputDto.productLine,
        Language: this.activeLang,
      };
      getExportCustomerList(postData).then((res) => {
        if (res.result) {
          var data = res.result;
          //导入数据里有null会导致文件损坏
          const dataSource = data.map((item) => {
            Object.keys(item).forEach((key) => {
              // 后端传null node写入会有问题
              if (item[key] === null) {
                item[key] = "";
              }

              if (Array.isArray(item[key])) {
                item[key] = item[key].join(",");
              }
            });
            return item;
          });
          dataSource.forEach((item) => {
            let rowData = [];
            rowData = [
              item.customerName,
              item.customerCode,
              item.brandCode,
              item.customerCenter,
              item.customerType == "Other" ? "Rotary" : item.customerType,
              item.manageCpName,
              item.manageCpCode,
              this.$t("desc."+item.companyType),
              item.provinceName,
              item.cityName,
              item.address,
              item.industry,
              item.longitude,
              item.latitude,
            ];
            exportData.push(rowData);
          });
          exportExcelNew(exportData, fileName);
          // exportExcel(headers, dataSource, fileName);
          this.loading = false;
        }
      });
    },
    uploadFile() {
      let that = this;
      this.importLoading = true;
      var datalist = that.form.datalist;
      var propertys = Object.keys(datalist[0]);
      // if (propertys.length != 55) {
      //   that.form.datalist = [];
      //   that.$message({
      //     showClose: true,
      //     message: "导入格式不正确",
      //     type: "error",
      //   });
      //   return false;
      // }
      var msgArr = [];
      var index = 2;
      var postData = [];
      let customerCharater = {
        "Directly Managed":"直管",
        "Distributor Managed":"经销商",
        "Service Distributor":"服务经销商",
        "Middleman":"中间商",
        "Others":"其他",
      }
      datalist.map((v) => {
        let obj = {};
        if (that.activeLang == 'en') {
          obj.CustomerCode = v["Customer Code"];
          obj.CustomerName = v["Customer Name"];
          obj.CustomerCenter = v["Customer Center"];
          obj.CustomerType = v["Product Line"];
          obj.Industry = v["Sub-sector"];
          obj.Address = v["Address"];
          obj.CompanyType = customerCharater[v["Customer Charater"]];
          obj.ProvinceName = v["Province"];
          obj.CityName = v["City"];
          obj.ManageCpCode = v["Management Owner Code"];
          obj.ManageCpName = v["Management Owner"];
          obj.BrandCode = v["Brand"];
        } else {
          obj.CustomerCode = v["客户代码"];
          obj.CustomerName = v["客户名称"];
          obj.CustomerCenter = v["客户中心"];
          obj.CustomerType = v["产品线"];
          obj.Industry = v["新行业小类"];
          obj.Address = v["客户详细地址"];
          obj.CompanyType = v["单位性质"];
          obj.ProvinceName = v["省"];
          obj.CityName = v["市"];
          obj.ManageCpCode = v["管理单位代码"];
          obj.ManageCpName = v["管理单位"];
          obj.BrandCode = v["品牌"];
        }
        
        if (obj.CompanyType == "直管" || obj.CompanyType == "Directly Managed") {
          obj.ManageCpName = obj.CustomerCenter;
          obj.ManageCpCode = "";
        }
        var msg = "";
        if (obj.CustomerCode == undefined || obj.CustomerCode == "") {
          msg = that.$t("importError.customerCodeIsEmpty");
        }
        if (obj.CustomerName == undefined || obj.CustomerName == "") {
          msg += that.$t("importError.customerNameIsEmpty");
        }
        if (obj.CompanyType == undefined || obj.CompanyType == "") {
          msg += that.$t("importError.customerCharaterIsEmpty");
        }
        if (msg != "") {
          msgArr.push(that.$t("importError.exceptionLine") + index + that.$t("importError.行异常:") + msg);
        } else {
          if (that.find(postData, obj) > -1) {
            msgArr.push(
              that.$t("importError.exceptionLine") +
                index +
                that.$t("importError.行异常:")+
                that.$t("importError.已存在:")+
                that.$t("importError.客户代码")+"[" +
                obj.CustomerCode +
                "]、"+that.$t("importError.单位性质")+"[" +
                obj.CompanyType +
                "]、"+that.$t("importError.管理单位代码")+"[" +
                obj.ManageCpCode +
                "]"+that.$t("importError.相同的数据")
            );
          } else {
            postData.push(obj);
          }
        }
        index++;
      });
      if (msgArr.length > 0) {
        that.$message({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: msgArr.join("<br/>"),
          type: "error",
        });
        return false;
      }
      importCustomer(postData, 2 * 60 * 1000)
        .then((res) => {
          (that.importLoading = false), (that.dialogImportClient = false);
          that.$message({
            showClose: true,
            message: that.$t("tips.importSuccess"),
            type: "success",
          });
          that.getDataList();
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    find(array, model) {
      var index = array.findIndex(
        (item) =>
          item.CustomerCode === model.CustomerCode &&
          item.CompanyType === model.CompanyType &&
          item.ManageCpCode === model.ManageCpCode
      );
      return index; // -1 说明array中不存在id为str的对象
    },
  },
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
